import {memo, PropsWithChildren} from 'react'
import {Modal} from 'react-bootstrap'
import {useIntl} from 'react-intl'
import {Button} from '../../../../../_gori/partials/widgets'

type ModalTemplateProps = PropsWithChildren<{
  id: string
  show: boolean
  handleClose: () => void
  title?: string
  showFooter?: boolean
  loadingPrimaryBtn?: boolean
  loadingSecondaryBtn?: boolean
  disabledPrimaryBtn?: boolean
  disabledSecondaryBtn?: boolean
  onClickPrimaryBtn?: () => void
  onClickSecondaryBtn?: () => void
  titlePrimaryBtn?: string
  titleSecondaryBtn?: string
  secondaryBtnWithClose?: boolean
  dialogClassName?: string
  contentClassName?: string
  bodyClassName?: string
  showPrimaryBtn?: boolean
}>
export const ModalTemplate = memo(
  ({
    id,
    show,
    handleClose,
    title = 'ADD_TO_A1_BATCH',
    showFooter = true,
    loadingPrimaryBtn = false,
    loadingSecondaryBtn = false,
    disabledPrimaryBtn = false,
    disabledSecondaryBtn = false,
    onClickPrimaryBtn = () => {},
    onClickSecondaryBtn = () => {},
    titlePrimaryBtn = 'SUBMIT',
    titleSecondaryBtn = 'CANCEL',
    children,
    dialogClassName = 'modal-size-lg h-auto',
    contentClassName = 'modal-padding',
    bodyClassName = '',
    showPrimaryBtn = true,
    secondaryBtnWithClose = true,
  }: ModalTemplateProps) => {
    const intl = useIntl()

    return (
      <div>
        <Modal
          id={id}
          tabIndex={-1}
          aria-hidden='true'
          centered
          dialogClassName={dialogClassName}
          contentClassName={contentClassName}
          show={show}
          backdrop='static'
          onHide={() => handleClose()}
        >
          <Modal.Header closeButton>
            <Modal.Title bsPrefix={'fw-bolder fs-1'}>{intl.formatMessage({id: title})}</Modal.Title>
          </Modal.Header>
          <Modal.Body className={bodyClassName}>{children}</Modal.Body>
          {showFooter && (
            <Modal.Footer>
              <div className='d-flex justify-content-end'>
                <Button
                  className='btn btn-advanced-secondary me-3'
                  label={intl.formatMessage({id: titleSecondaryBtn})}
                  event={() => {
                    onClickSecondaryBtn()
                    if (secondaryBtnWithClose) {
                      handleClose()
                    }
                  }}
                  loading={loadingSecondaryBtn}
                  disabled={disabledSecondaryBtn}
                />
                {showPrimaryBtn && (
                  <Button
                    className={'btn btn-advanced-primary'}
                    label={intl.formatMessage({id: titlePrimaryBtn})}
                    loadingText={intl.formatMessage({id: titlePrimaryBtn})}
                    disabled={disabledPrimaryBtn}
                    loading={loadingPrimaryBtn}
                    event={onClickPrimaryBtn}
                  />
                )}
              </div>
            </Modal.Footer>
          )}
        </Modal>
      </div>
    )
  }
)
